import React, { useContext, useEffect, useState } from "react";
import Modal from "./Modal";
import { AnimatePresence, motion } from "framer-motion";
import { CodesContext } from "contexts/CodesContext";

const steps = [
  { label: "Voorbereiden", progress: 15 },
  { label: "Unieke codes aanmaken", progress: 33 },
  { label: "PDF genereren", progress: 66 },
  { label: "Bijna klaar", progress: 100 },
];

const STEP_DURATION = 3000;

const ModalCodesCreateLoading = () => {
  // const { loadingCreate } = useContext(CodesContext);
  const loadingCreate = true; // Simulate loading state for demonstration purposes
  const [stepIndex, setStepIndex] = useState(0);

  // only a single loading boolean is available, so the steps are simulated on a timer
  useEffect(() => {
    if (!loadingCreate) {
      setStepIndex(0);
      return;
    }
    const interval = setInterval(() => {
      setStepIndex((current) => Math.min(current + 1, steps.length - 1));
    }, STEP_DURATION);
    return () => clearInterval(interval);
  }, [loadingCreate]);

  const step = steps[stepIndex];

  return (
    <AnimatePresence>
      <Modal width={400}>
        <div className="flex flex-col gap-4 items-center">
          <h1 className="text-center text-2xl font-bold">
            Jouw fotohoek wordt nu aangemaakt
          </h1>
          <div className="bg-slate-100 rounded-full h-2 mt-4 w-48 overflow-hidden">
            <motion.div
              className="h-2 rounded-full bg-gradient-to-r from-blue-300 via-blue-700 to-blue-300 bg-[length:300%_100%]"
              initial={false}
              animate={{
                width: `${step.progress}%`,
                backgroundPosition: ["0% 0%", "100% 0%"],
              }}
              transition={{
                width: { duration: 0.4, ease: "easeInOut" },
                backgroundPosition: {
                  duration: 0.8,
                  ease: "linear",
                  repeat: Infinity,
                  repeatType: "mirror",
                },
              }}
            />
          </div>
          <div>
            <p className="font-bold text-center mt-4">
              Stap {stepIndex + 1} van {steps.length}
            </p>
            <AnimatePresence exitBeforeEnter>
              <motion.p
                key={stepIndex}
                className="text-center"
                initial={{ opacity: 0, y: 6 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -6 }}
                transition={{ duration: 0.2 }}
              >
                {step.label}
                <span className="inline-flex ml-1 align-bottom">
                  {[0, 1, 2].map((dot) => (
                    <motion.span
                      key={dot}
                      className="inline-block"
                      animate={{ opacity: [0.2, 1, 0.2], y: [0, -1, 0] }}
                      transition={{
                        duration: 1,
                        repeat: Infinity,
                        ease: "easeInOut",
                        delay: dot * 0.18,
                      }}
                    >
                      .
                    </motion.span>
                  ))}
                </span>
              </motion.p>
            </AnimatePresence>
          </div>
        </div>
      </Modal>
    </AnimatePresence>
  );
};

export default ModalCodesCreateLoading;
